import { defineAbility } from '@casl/ability';

export const permissions: any = defineAbility((can) => {
  can('put', 'users');
  can('update', 'task');
  can('set', 'task-template');
  can('upsert', 'task-group');
  can('access', 'rm-ui');
  can('upsert', 'resource');
  can('upsert', 'resource-schedules');
  can('upsert', 'resource-events');
  can('put', 'roles');
  can('set', '');
  can('reset', 'users');
  can('access', 'complex-loss');
  can('upsert', 'complex-loss');
});

export const noUpsertResourcePermission: any = defineAbility((can) => {
  can('put', 'users');
  can('update', 'task');
  can('set', 'task-template');
  can('upsert', 'task-group');
  can('access', 'rm-ui');
});

export const noPermissions: any = defineAbility((can) => {
  can('access', 'rm-ui');
});

export const partialAdminPermissions: any = defineAbility((can) => {
  can('put', 'users');
  can('access', 'rm-ui');
  can('access, rm-ui');
});
